import { IconActivity } from '@tabler/icons-react'

export const PERMISSION_SETS_ACTIVITY = {
  id: 'Activity',
  description: 'Grant access to view activity.',
  icon: IconActivity,
  sections: [
    {
      title: 'permissions',
      permissions: [
        {
          type: 'checkbox',
          label: 'View their own activity',
        },
        {
          type: 'checkbox',
          label: `View others' activity`,
        },
      ],
    },
  ],
}
